/**
 * 主单号管理 API
 */
import apiClient from "./axios";

const BASE_PATH = "/v3/sales";

export const mawbStockApi = {
    getList: (params = {}) => apiClient.get(`${BASE_PATH}/mawb-stocks`, { params }),
    getById: (id) => apiClient.get(`${BASE_PATH}/mawb-stocks/${id}`),
    getAllocationSummary: (id) =>
        apiClient.get(`${BASE_PATH}/mawb-stocks/${id}/allocation-summary`),
    getAllocationDates: (id) =>
        apiClient.get(`${BASE_PATH}/mawb-stocks/${id}/allocation-dates`),
    getAllocationSummaryBulk: (stockIds) =>
        apiClient.post(`${BASE_PATH}/mawb-stocks/allocation-summary-bulk`, { stock_ids: stockIds }),
    create: (data) => apiClient.post(`${BASE_PATH}/mawb-stocks`, data),
    remove: (id) => apiClient.delete(`${BASE_PATH}/mawb-stocks/${id}`),
    importNumbers: (data) => apiClient.post(`${BASE_PATH}/mawb-stocks/import`, data),
};

export const mawbUsageApi = {
    getList: (params = {}) => apiClient.get(`${BASE_PATH}/mawb-usages`, { params }),
    getByStock: (stockId, params = {}) =>
        apiClient.get(`${BASE_PATH}/mawb-usages`, { params: { stock_id: stockId, ...params } }),
    getAllocationDistinct: (params = {}) =>
        apiClient.get(`${BASE_PATH}/mawb-usages/allocation-distinct`, { params }),
    allocate: (data) => apiClient.post(`${BASE_PATH}/mawb-usages/allocate`, data),
    deallocate: (data) => apiClient.post(`${BASE_PATH}/mawb-usages/deallocate`, data),
    updateStatus: ({ id, data }) => apiClient.patch(`${BASE_PATH}/mawb-usages/${id}/status`, data),
};
